export const isLimitReached = (count: number, max: number | null | undefined): boolean => max != null && count >= max;
